import { action, observable, makeObservable } from 'mobx'
import ModalViewModel from 'infra/ModalViewModel'
import JobScopeChangeRequest from 'jobs/JobScopeChange'

/**
 * View Model for viewing a scope change request.
 */
export default class ViewScopeChangesViewModel extends ModalViewModel {
  @observable scopeChangeRequest = JobScopeChangeRequest.none

  constructor() {
    super()
    makeObservable(this)
  }

  @action.bound
  set(scopeChangeRequest: JobScopeChangeRequest) {
    this.scopeChangeRequest = scopeChangeRequest
  }
}
